import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/animations/rhoneacademy-timeout.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const RhoneAcademyTimeoutAnimation = ({ className }) => (
    <svg
        width="238"
        height="140"
        viewBox="0 0 238 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames(styles.container, className)}
    >
        <g>
            <path d="M128.632 65.9084H113.741V131.938H128.632V65.9084Z" fill="white" />
            <path d="M145.499 124.484H96.8916V139.375H145.499V124.484Z" fill="white" />
            <path
                d="M121.178 76.9336C99.9248 76.9336 82.7109 59.7197 82.7109 38.4668V0H159.645V38.4668C159.645 59.7197 142.431 76.9336 121.178 76.9336Z"
                fill="white"
            />
            <g clipPath="url(#glass_center)">
                <rect
                    x="80.178"
                    y="0"
                    width="85"
                    height="85"
                    fill="#EA4F57"
                    className={styles.centerGlass}
                />
            </g>
        </g>
        <g>
            <path d="M34.2766 85.8438H23.4248V133.966H34.2766V85.8438Z" fill="white" />
            <path d="M46.5672 128.523H11.1514V139.375H46.5672V128.523Z" fill="white" />
            <path
                d="M28.8508 93.8704C13.3705 93.8704 0.819824 81.3197 0.819824 65.8394V37.8083H56.8818V65.8394C56.8818 81.3197 44.3312 93.8704 28.8508 93.8704Z"
                fill="white"
            />
            <g clipPath="url(#glass_left)">
                <rect
                    x="0"
                    y="36"
                    width="58"
                    height="59"
                    fill="#EA4F57"
                    className={styles.sideGlass}
                />
            </g>
        </g>
        <g>
            <path d="M215.395 85.8438H204.543V133.966H215.395V85.8438Z" fill="white" />
            <path d="M227.668 128.523H192.252V139.375H227.668V128.523Z" fill="white" />
            <path
                d="M209.969 93.8704C194.489 93.8704 181.938 81.3197 181.938 65.8394V37.8083H238V65.8394C238 81.3197 225.449 93.8704 209.969 93.8704Z"
                fill="white"
            />
            <g clipPath="url(#glass_right)">
                <rect
                    x="181"
                    y="36"
                    width="58"
                    height="59"
                    fill="#EA4F57"
                    className={styles.sideGlass}
                />
            </g>
        </g>
        <defs>
            <clipPath id="glass_center">
                <path d="M121.178 76.9336C99.9248 76.9336 82.7109 59.7197 82.7109 38.4668V0H159.645V38.4668C159.645 59.7197 142.431 76.9336 121.178 76.9336Z" />
            </clipPath>

            <clipPath id="glass_left">
                <path d="M28.8508 93.8704C13.3705 93.8704 0.819824 81.3197 0.819824 65.8394V37.8083H56.8818V65.8394C56.8818 81.3197 44.3312 93.8704 28.8508 93.8704Z" />
            </clipPath>

            <clipPath id="glass_right">
                <path d="M209.969 93.8704C194.489 93.8704 181.938 81.3197 181.938 65.8394V37.8083H238V65.8394C238 81.3197 225.449 93.8704 209.969 93.8704Z" />
            </clipPath>
        </defs>
    </svg>
);

RhoneAcademyTimeoutAnimation.propTypes = propTypes;
RhoneAcademyTimeoutAnimation.defaultProps = defaultProps;

export default RhoneAcademyTimeoutAnimation;
